<template>
    <div class="top-conversions">
        <div class="page-sub-title">{{ $t('Conversions') }}</div>
        <box class="alt">
            <b-table hover
                     :fields="fields"
                     :items="dataProvider"
                     :show-empty="true"
                     :busy="isBusy"
            >
                <template slot="empty">
                    <div class="empty-table">
                        <span>{{ $t('No data to display') }}</span>
                    </div>
                </template>
                <template slot="table-busy">
                    <div class="empty-table">
                        <img src="../../../images/loader_smaller.svg" alt="">
                    </div>
                </template>
                <template slot="conversionId" slot-scope="data">
                    <span>{{ data.item.conversionId }}</span>
                </template>
                <template slot="conversion_dict" slot-scope="data">
                    <span>{{ data.item.conversion_dict }}</span>
                </template>
                <template slot="conversions" slot-scope="data">
                    <span class="nobr">{{ data.item.conversions | integer }}</span>
                </template>
            </b-table>
        </box>
    </div>
</template>

<script>

export default {
    name: 'dasboard-conversions',

    data: function () {
        return {
            isBusy: false,
            fields: [
                {key:'conversionId', label: this.$t('ID'), sortable: false},
                {key:'conversion_dict', label: this.$t('Name'), sortable: false},
                {key:'conversions', label: this.$t('Conversions'), sortable: false},
            ],
        }
    },

    methods: {
        dataProvider() {
            this.isBusy = true;

            const data = {
                groupBy: [ 'conversionId' ],
                orderField: "conversionId",
                orderDir: 'asc',
                rowsOnPage: 10,
                page: 1
            };

            return this.$axios.post('/statistic/conversions', data)
                .then(response => {
                    this.isBusy = false;

                    return response.data.data;
                })
                .catch(() => {
                    this.isBusy = false;

                    return [];
                });
        },
    }

}
</script>

<style lang="scss" scoped>
    .nobr {
        white-space: nowrap;
    }
    .top-conversions .empty-table {
        min-height: 180px;
    }
</style>
